import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar';
import icon from '../../images/icon.png';
import android_qr from '../../images/android-qr.png';
import ios_qr from '../../images/ios-qr.png';

export const InstallApp = () => {
  return (
    <Fragment>
      <Navbar />
      <div className='m-5'>
        <div>
          <h2>App Installation Guide</h2>
        </div>
        <div>
          <p style={{ fontSize: '1.5em' }}>
            <b>To install the app onto your mobile device, follow the instructions below:</b>
          </p>
          <hr />

          <ol style={{ fontSize: '1.2em' }}>
            <li>If you have the Inventory App installed on your device, check for available updates in the App Store or Google Play store</li>
            <li>If you need to install the Inventory App, click on the appropriate link below and install the app:</li>
            <ul>
              <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '20px' }}>
                <div style={{ textAlign: 'center', marginRight: '200px' }}>
                  <img alt='Android QR Code' src={android_qr} style={{ width: '250px', height: '250px'}} />
                  <p>
                    <b>Android (Play Store)</b>
                  </p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <img src={ios_qr} style={{ width: '250px', height: '250px' }} />
                  <p>
                    <b>iOS (App Store)</b>
                  </p>
                </div>
              </div>

            
            </ul>

            <li>
              Find the Inventory Scan icon&nbsp;
              <img alt='' src={icon} style={{ width: '30px', height: '30px' }} />
              &nbsp;and launch the application.
              <ul>
                <li>Click 'Login with OneLogin' and use your AACO username and password to log in</li>
              </ul>
            </li>
          </ol>
        </div>
      </div>
    </Fragment>
  );
};
